import asiakasClass from "../asiakas/asiakasClass";
import { fetchAsiakasPersonSettings } from "../auth/asiakasAuthClass";
import authClass from "../auth/auth";
import betoniClass from "../betoni/betoniClass";
import { checkResponse, parseJSONDate } from "src/components/js/statics1";
import { keikka_varmenne_save_to_db } from "./KeikkaFunctions";
import { asiakas_fetch } from "../asiakas/AsiakasFunctions";
import { vehicle_get_parseJson } from "src/components/vehicle/VehicleFunctions";
import { asiakas_hasToimitus } from "../asiakas/asiakasSettingsClass";
import { sijainti_get } from "../sijainti/SijaintiFunctions";
import { addStepLogMessage } from "./handleKeikka";

export async function reloadKeikkaDataAll(
  keikkaData,
  preserveMuokkausTila = false,
  user,
  token,
  socket
) {
  console.log("RELOADKEIKKADATAALL");
  const personId = user.personId;
  const origTilaId = keikkaData.tila.keikkaTilaId;
  const origMuokkausTila = keikkaData.tila.muokkausTila;
  var start = new Date().getTime();
  await loadKeikkaData__only_load_and_return(keikkaData, user, token, socket);
  var end = new Date().getTime();

  if (preserveMuokkausTila && keikkaData.tila.muokkausTila) {
    keikkaData.tila.keikkaTilaId = origTilaId;
    keikkaData.tila.muokkausTila = origMuokkausTila;
    await keikkaData.setAuthDataViaFetch(
      personId,
      keikkaData.keikkaId,
      keikkaData.tyomaa.tyomaaId,
      keikkaData.asiakas.asiakasId,
      keikkaData.tila.keikkaTilaId,
      token
    );
  }
  const timeForFuncExecutionMs = end - start;
  return timeForFuncExecutionMs;
}

export async function loadKeikkaData__only_load_and_return(keikkaData, user, token, socket) {
  await loadKeikkaData_init(keikkaData, user, token, socket);
  await loadKeikkaData_Auth(keikkaData, user, token);
  await loadKeikkaData_betonit(keikkaData, user, token);
  await loadKeikkaData_finalize(keikkaData, user, token);
  return keikkaData;
}

export async function loadKeikkaData_init(keikkaData, user, token, socket, ownerAsiakasId) {
  const keikkaId = keikkaData.keikkaId;
  if (ownerAsiakasId === undefined) ownerAsiakasId = keikkaData.ownerAsiakasId;
  if (ownerAsiakasId === undefined || !ownerAsiakasId) ownerAsiakasId = 0;
  const url1 =
    import.meta.env.VITE_SERVER_URL + "/api/keikka/get/" + keikkaId + "/" + ownerAsiakasId || 0;
  const response = await fetch(url1, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  if (response.status === 504) {
    // Api node server is working, sql server is not responding
    return { status: "error", errorTxt: "504 Tietokantapalvelin ei vastaa", errorNum: 504 };
  }
  if (response.status === 404) {
    // Keikka not found
    return { status: "error", errorTxt: "404 Tilausta ei löydy", errorNum: 404 };
  }
  const keikkaJson = await response.json();
  const keikkaItems = keikkaJson.keikkaData;
  const tyomaaItems = keikkaJson.tyomaaData;
  let keikkaTyomaaItems = keikkaJson.keikkaTyomaaData;
  const asiakasList = keikkaJson.asiakasData;
  const vehicleItems = keikkaJson.vehicleData;
  const tilaItems = keikkaJson.tilaData;

  if (!keikkaItems) return { status: "error", errorTxt: "404 Tilausta ei löydy", errorNum: 404 };
  if (keikkaItems[0] == "error") {
    keikkaData.errors.errorTxt = keikkaItems[1];
    keikkaData.errors.errorNum = keikkaItems[2];
    keikkaData.isLoading = false;
    keikkaData.isBackgroundLoading = false;
    return keikkaData;
  }
  // set asiakasData
  let keikkaAsiakasItems = keikkaJson.keikkaAsiakasData;

  if (keikkaAsiakasItems[0]?.asiakasId > 0) keikkaAsiakasItems = keikkaAsiakasItems[0];
  if (!keikkaAsiakasItems.asiakasId) {
    // jos ei ole keikka asiakas tietoa, käytetään global asiakas tietoa
    console.log("keikka-asiakas not found using global asiakas");
    keikkaAsiakasItems = asiakasList.find((asiakas) => asiakas.asiakasId === keikkaItems.asiakasId);
  }
  if (keikkaTyomaaItems[0]?.tyomaaId > 0) keikkaTyomaaItems = keikkaTyomaaItems[0];
  if (!keikkaTyomaaItems.tyomaaId) {
    // jos ei ole keikka työmaa tietoa, käytetään global työmaa tietoa
    console.log("keikka-tyomaa not found using global tyomaa");
    keikkaTyomaaItems = tyomaaItems.find((tyomaa) => tyomaa.tyomaaId === keikkaItems.tyomaaId);
  }
  keikkaData.asiakas.setDataFromJson(keikkaAsiakasItems);

  // set tyomaaData
  keikkaData.tyomaa.setTyomaa(keikkaTyomaaItems);

  // set tilaData
  keikkaData.tila.setTilaDataFromJson(tilaItems);

  // load toimittajat
  await Promise.all([
    _loadKeikkaData_betoniToimittaja(),
    _loadKeikkaData_pumppuToimittaja(),
    _loadKeikkaData_lattiaToimittaja(),
  ]);

  // set pumppu Vehicle
  keikkaData.pumppu.vehicle = vehicle_get_parseJson(vehicleItems);

  keikkaData.foreignKey = keikkaItems.foreignKey;
  keikkaData.lockedString = keikkaItems.locked;
  keikkaData.isLocked = keikkaItems.isLocked;
  keikkaData.sourceAsiakasId = keikkaItems.sourceAsiakasId;
  keikkaData.asiakas.asiakasId = keikkaItems.asiakasId;
  keikkaData.tyomaa.tyomaaId = keikkaItems.tyomaaId;
  keikkaData.varmenneDB = keikkaItems.varmenne;
  keikkaData.keikkaComment = keikkaItems.keikkaComment;
  keikkaData.keikkaOtsikko = keikkaItems.keikkaOtsikko;
  keikkaData.ownerAsiakasId = keikkaItems.ownerAsiakasId;
  keikkaData.keikkaContactPerson.personId = keikkaItems.keikkaContactPersonId
    ? keikkaItems.keikkaContactPersonId
    : keikkaItems.personId;
  keikkaData.keikkaContactPerson.personFirstName = keikkaItems.personFirstName;
  keikkaData.keikkaContactPerson.personLastName = keikkaItems.personLastName;
  keikkaData.keikkaContactPerson.personEmail = keikkaItems.personEmail;
  keikkaData.keikkaContactPerson.personMemo = keikkaItems.personMemo;
  keikkaData.keikkaContactPerson.personPhone = keikkaItems.personPhone;
  keikkaData.pumppu.keikkaId = keikkaData.keikkaId;
  keikkaData.pumppu.pumppuPuomi = keikkaItems.pumppuPuomi;
  keikkaData.pumppu.pumppuLinja = keikkaItems.pumppuLinja;
  keikkaData.pumppu.pumppuAika = parseJSONDate(keikkaItems.pumppuAika);
  keikkaData.pumppu.betoniAika = parseJSONDate(keikkaItems.betoniAika);
  keikkaData.pumppu.tyhjänäTyömaalle = keikkaItems.tyhjänäTyömaalle;
  keikkaData.pumppu.originalAika = keikkaItems.pumppuAika;
  keikkaData.pumppu.pumppuKesto = keikkaItems.pumppuKesto;
  keikkaData.pumppu.kellonAikaTxt = keikkaItems.kellonAikaTxt;
  keikkaData.pumppu.ehdotaAikaa = keikkaItems.ehdotaAikaa;

  // set other keikkaData.tila items
  keikkaData.tila.keikkaId = keikkaId;
  keikkaData.tila.isStepLogAccepted = keikkaItems.isStepLogAccepted;
  keikkaData.tila.isLaskutusSet = keikkaItems.isLaskutusSet;
  keikkaData.tila.isToimitusSet = keikkaItems.isToimitusSet;
  keikkaData.laskutus.isBetoniSuoraLaskutus = keikkaItems.isBetoniSuoraLaskutus;
  keikkaData.laskutus.isPumppuSuoraLaskutus = keikkaItems.isPumppuSuoraLaskutus;

  // set modules
  keikkaData.modules.keikkaId = keikkaId;
  keikkaData.modules.hasBetoni = keikkaItems.hasBetoni;
  keikkaData.modules.hasPumppu = keikkaItems.hasPumppu;
  keikkaData.modules.hasLattia = keikkaItems.hasLattia;
  const hasToimitus =
    asiakas_hasToimitus(keikkaData.pumppuToimittaja) ||
    asiakas_hasToimitus(keikkaData.betoniToimittaja) ||
    asiakas_hasToimitus(keikkaData.lattiaToimittaja);
  keikkaData.modules.hasToimitus = hasToimitus;
  keikkaData.vehicleTypeId = keikkaItems.vehicleTypeID;

  var today = new Date();
  var endTime = new Date(keikkaData.pumppu.pumppuAika);
  endTime.setHours(endTime.getHours() + keikkaData.pumppu.pumppuKesto / 60);

  if (
    keikkaData.tila.keikkaTilaId === 4 &&
    keikkaData.pumppu.pumppuAika < today &&
    endTime > today
  ) {
    console.log("UPDATE TO TOIMITUS MENEILLÄÄN");
    keikkaData.tila.keikkaTilaId = 5; // set tila to toimitus meneillään
    await keikkaData.tila.saveKeikkaTilaToDB(
      user.personId,
      token,
      true,
      socket,
      keikkaData.varmenne
    );
  }

  if (
    (keikkaData.tila.keikkaTilaId === 4 || keikkaData.tila.keikkaTilaId === 5) &&
    endTime < today
  ) {
    console.log("UPDATE TO TILAUS TOIMITETTU " + keikkaData.keikkaId);
    addStepLogMessage(keikkaData, socket, 0, "Tilaus toimitettu (woia)", 21);
    keikkaData.tila.keikkaTilaId = 9; // set tila to toimitettu
    await keikkaData.tila.saveKeikkaTilaToDB(
      user.personId,
      token,
      true,
      socket,
      keikkaData.varmenne
    );
  }

  async function _loadKeikkaData_lattiaToimittaja() {
    keikkaData.lattiaToimittaja = new asiakasClass(keikkaItems.lattiaAsiakasId);
    keikkaData.lattiaToimittaja = await loadKeikkaData_lattiaToimittaja(keikkaData, user, token);
    if (keikkaData.lattiaToimittaja?.asiakasId > 0) {
      keikkaData.lattiaToimittaja.sijaintiId = keikkaItems.lattiaSijaintiId;
      keikkaData.lattiaToimittaja.sijaintiMatkaAika = keikkaItems.lattiaMatkaAika;
      keikkaData.lattiaToimittaja.sijaintiMatkaM = keikkaItems.lattiaMatkaM;
      keikkaData.lattiaToimittaja.sijainti = await sijainti_get(
        keikkaData.lattiaToimittaja.sijaintiId,
        token
      );
    }
  }

  async function _loadKeikkaData_pumppuToimittaja() {
    keikkaData.pumppuToimittaja = new asiakasClass(keikkaItems.pumppuAsiakasId);
    keikkaData.pumppuToimittaja = await loadKeikkaData_pumppuToimittaja(keikkaData, user, token);
    keikkaData.pumppuToimittaja.sijaintiId = keikkaItems.pumppuSijaintiId;
    keikkaData.pumppuToimittaja.sijaintiMatkaAika = keikkaItems.pumppuMatkaAika;
    keikkaData.pumppuToimittaja.sijaintiMatkaM = keikkaItems.pumppuMatkaM;
    keikkaData.pumppuToimittaja.sijainti = await sijainti_get(
      keikkaData.pumppuToimittaja.sijaintiId,
      token
    );
  }

  async function _loadKeikkaData_betoniToimittaja() {
    keikkaData.betoniToimittaja = new asiakasClass(keikkaItems.betoniAsiakasId);
    keikkaData.betoniToimittaja = await loadKeikkaData_betoniToimittaja(keikkaData, user, token);
    keikkaData.betoniToimittaja.sijaintiId = keikkaItems.betoniSijaintiId;
    keikkaData.betoniToimittaja.sijaintiMatkaAika = keikkaItems.betoniMatkaAika;
    keikkaData.betoniToimittaja.sijaintiMatkaM = keikkaItems.betoniMatkaM;
    keikkaData.betoniToimittaja.sijainti = await sijainti_get(
      keikkaData.betoniToimittaja.sijaintiId,
      token
    );
  }
}
export async function loadKeikkaData_asiakasPersonSettings(keikkaData, user, token) {
  const asiakasId = keikkaData.asiakas.asiakasId;
  const personId = user.personId;
  const asiakasPersonSettings = await fetchAsiakasPersonSettings(asiakasId, personId, token);
  keikkaData.asiakas.auth.settings = asiakasPersonSettings;
  keikkaData.asiakas.auth.isSettingsLoaded = true;
}

export async function loadKeikkaData_pumppuToimittaja(keikkaData, person, token) {
  // toimittajat
  if (keikkaData.pumppuToimittaja.asiakasId > 0) {
    const fetchResult = await asiakas_fetch(
      person,
      keikkaData.pumppuToimittaja.asiakasId,
      token,
      keikkaData.keikkaId,
      null,
      true,
      true
    );
    const _asiakas = fetchResult.globalAsiakas;
    _asiakas.sijaintiId = keikkaData.pumppuToimittaja.sijaintiId;
    _asiakas.sijaintiMatkaM = keikkaData.pumppuToimittaja.sijaintiMatkaM;
    _asiakas.sijaintiMatkaAika = keikkaData.pumppuToimittaja.sijaintiMatkaAika;
    _asiakas.sijainti = await sijainti_get(_asiakas.sijaintiId, token);
    keikkaData.pumppuToimittaja = _asiakas;
    return _asiakas;
  }
  return keikkaData.pumppuToimittaja;
}
export async function loadKeikkaData_betoniToimittaja(keikkaData, person, token) {
  // toimittajat
  if (!keikkaData.betoniToimittaja.isLoaded && keikkaData.betoniToimittaja.asiakasId > 0) {
    const fetchResult = await asiakas_fetch(
      person,
      keikkaData.betoniToimittaja.asiakasId,
      token,
      keikkaData.keikkaId,
      null,
      true,
      true
    );
    const _asiakas = fetchResult.globalAsiakas;
    _asiakas.sijaintiId = keikkaData.betoniToimittaja.sijaintiId;
    _asiakas.sijaintiMatkaM = keikkaData.betoniToimittaja.sijaintiMatkaM;
    _asiakas.sijaintiMatkaAika = keikkaData.betoniToimittaja.sijaintiMatkaAika;
    _asiakas.sijainti = await sijainti_get(_asiakas.sijaintiId, token);
    keikkaData.betoniToimittaja = _asiakas;
    return _asiakas;
  }
  return keikkaData.betoniToimittaja;
}
export async function loadKeikkaData_lattiaToimittaja(keikkaData, person, token) {
  // toimittajat
  if (!keikkaData.lattiaToimittaja.isLoaded && keikkaData.lattiaToimittaja.asiakasId > 0) {
    const fetchResult = await asiakas_fetch(
      person,
      keikkaData.lattiaToimittaja.asiakasId,
      token,
      keikkaData.keikkaId,
      null,
      true,
      true
    );
    keikkaData.lattiaToimittaja = fetchResult.globalAsiakas;
    return fetchResult.globalAsiakas;
  }
  return keikkaData.lattiaToimittaja;
}
export async function loadKeikkaData_Auth(keikkaData, user, token) {
  const personId = user.personId;
  const keikkaId = keikkaData.keikkaId;
  const tyomaaId = keikkaData.tyomaa.tyomaaId;
  const asiakasId = keikkaData.asiakas.asiakasId;
  const keikkaTilaId = keikkaData.tila.keikkaTilaId;
  const _auth = new authClass();
  await _auth.init(personId, keikkaId, tyomaaId, asiakasId, keikkaTilaId, token);
  keikkaData.tyomaa.auth = _auth.tyomaaAuth;
  keikkaData.asiakas.auth = _auth.asiakasAuth;
  keikkaData.auth = _auth.keikkaAuth;
  if (!_auth.tyomaaAuth.read && !_auth.keikkaAuth.read && !_auth.asiakasAuth.read) {
    keikkaData.keikkaId = 0;
    keikkaData.tyomaa.tyomaaId = 0;
    keikkaData.asiakas.asiakasId = 0;
    keikkaData.tila.keikkaTilaSelite = "2. Ei pääsyä";
    keikkaData.tila.keikkaTilaId = -100;
    keikkaData.tile.keikkaTilaCategory = "3. Ei pääsyä";
    keikkaData.errors.errorTxt = "err";
    keikkaData.errors.errorNum = 403;
    keikkaData.isLoading = false;
    keikkaData.isBackgroundLoading = false;
  }
  return keikkaData;
}

// export async function loadKeikkaData_vehicle(keikkaData, token) {
//   const vehicleId = keikkaData.pumppu.vehicle?.vehicleId;
//   if (!vehicleId) {
//     console.log("loadKeikkaData_vehicle: vehicleId not found");
//     return;
//   }
//   keikkaData.pumppu.vehicle = await vehicle_fetch(vehicleId, token);
// }

export async function loadKeikkaData_Pumpparit(keikkaData, token) {
  await keikkaData.pumppu.initPumppariList(token);
}

export async function loadKeikkaData_Betoni_Main(keikkaData, user, token) {
  const url = "/api/keikka/betoni/list/";
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url + keikkaData.keikkaId, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "loadKeikkaData:loadKeikkaData_Betonit");
  if (!cResponse.success) return false;
  const keikkaBetoniJson = await cResponse.data.betonit;
  //keikkaData.betoni = [];
  let _betonit = [];
  for (let i = 0; i < keikkaBetoniJson.length; i++) {
    const _betoni = new betoniClass();

    await _betoni.loadApiData(keikkaBetoniJson[i].keikkaBetoniId, token, false);
    _betonit.push(_betoni);
  }
  // sort keikkaData.betoni by orderNo
  _betonit.sort((a, b) => a.orderNo - b.orderNo);
  keikkaData.betoni = _betonit;
  //keikkaData.betoni.sort((a, b) => a.orderNo - b.orderNo);
}

export async function loadKeikkaData_betoniLisät(keikkaData, user, token) {
  for (let i = 0; i < keikkaData.betoni.length; i++) {
    const _betoni = keikkaData.betoni[i];

    await _betoni.loadApiData(_betoni.keikkaBetoniId, token, false);
  }
}

export async function loadKeikkaData_betonit(keikkaData, user, token) {
  const url = "/api/keikka/betoni/list/";
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url + keikkaData.keikkaId, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "loadKeikkaData:loadKeikkaData_Betonit");
  if (!cResponse.success) return false;
  const keikkaBetoniJson = cResponse.data.betonit;
  keikkaData.betoni = [];
  for (let i = 0; i < keikkaBetoniJson.length; i++) {
    const _betoni = new betoniClass();

    await _betoni.loadApiData(keikkaBetoniJson[i].keikkaBetoniId, token, false);
    keikkaData.betoni.push(_betoni);
  }
  // sort keikkaData.betoni by orderNo
  keikkaData.betoni.sort((a, b) => a.orderNo - b.orderNo);
}

export async function loadKeikkaData_finalize(keikkaData, user, token) {
  // set originalHashes
  keikkaData.originaluniqueHash = keikkaData.uniqueHash;
  keikkaData.asiakas.originalHash = keikkaData.asiakas.asiakasHash;
  keikkaData.tyomaa.originalHash = keikkaData.tyomaa.tyomaaHash;
  keikkaData.pumppu.originalHash = keikkaData.pumppu.pumppuHash;

  keikkaData.isLoading = false;
  keikkaData.isBackgroundLoading = false;

  // check if varmenneDB is same as varmenne
  if (keikkaData.varmenneDB !== keikkaData.varmenne) {
    console.log(
      "Varmenne:" +
        keikkaData.varmenneDB +
        " => " +
        keikkaData.varmenne +
        " for keikkaId:" +
        keikkaData.keikkaId
    );
    keikkaData.varmenneDB = keikkaData.varmenne;
    keikka_varmenne_save_to_db(keikkaData.keikkaId, keikkaData.varmenne, token);
  }
}
